import React, { useRef, useEffect, useMemo, useState } from "react";
import { Button, Badge, Row, Col, Modal, ProTableOt } from "./ot";

// ---- 工具：安全圖片（有錯誤時顯示灰底） ----
function SafeImage({ src, alt = "", className = "" }) {
    const [broken, setBroken] = useState(false);
    if (!src || broken) {
        return <div className={`inline-block ${className} bg-gray-100`} />;
    }
    return (
        <img
            src={src}
            alt={alt}
            className={className}
            onError={() => setBroken(true)}
            loading="lazy"
            decoding="async"
        />
    );
}

// ---- 子元件：底部預覽列（縮圖/小圖示） ----
function UploadPreviewRow({ uploadConfig = [], mediaType, files }) {
    const cfg = uploadConfig[mediaType];
    const Icon = cfg.icon;
    const top3 = files.slice(0, 3);
    const rest = files.length - top3.length;

    return (
        <div className="absolute bottom-1 left-1 right-1 flex gap-0.5 justify-center">
            {top3.map((file) => (
                cfg.preview === "image" ? (
                    <div key={file.id} className="w-4 h-4 rounded border overflow-hidden bg-white">
                        <SafeImage src={file.url} alt={file.name || "image"} className="w-full h-full object-cover" />
                    </div>
                ) : (
                    <div key={file.id} className={`w-4 h-4 rounded border ${cfg.miniBg} flex items-center justify-center`}>
                        <Icon className={`h-2 w-2 ${cfg.miniIconColor || ""}`} />
                    </div>
                )
            ))}
            {rest > 0 && (
                <div className="w-4 h-4 rounded border bg-gray-100 flex items-center justify-center">
                    <span className="text-xs text-gray-500">+</span>
                </div>
            )}
        </div>
    );
}

// ---- 子元件：單一卡片 ----
export default function MediaCard({
    actions,
    activeTabKey,
    bordered,
    cover,
    defaultActiveTabKey,
    extra,
    hoverable,
    loading,
    size,
    tabBarExtraContent,
    tabList,
    tabProps,
    title,
    type,
    classNames,
    styles,
    onTabChange,
    children,
    mediaType,
    mediaIcon,
    mediaNumber,
    mediaImageNumber,
    mediaNumberPosition,
    api,
    defaultValue,
    onMediaChange,

    uploadConfig = [],
    files = [],
    disabled,
    handleImport = () => { },
    handleDownload = () => { },
    set_upload_modal = () => { },
    upload_modal = true,
    importData = [],
    setImportData = () => { },
    columns = [],
    import_modal = false,
    set_import_modal = () => { },
    handleOver = () => { },
    handleReserve = () => { },
}) {
    const Icon = mediaIcon;
    const uploadFiles = files.filter(_ => _.type == mediaType);
    const count = uploadFiles.length;

    const [data, setData] = useState([]);
    const ref = useRef(0);
    const handleImportModal = (e) => {
        ref.current.click()
    }
    useEffect(() => {
        if (importData?.length != 0) {
            console.log(importData);
            set_import_modal(true);
            setData(importData);
        }
    }, [importData])
    const handlePreOver = () => {
        let data_tmp = [];
        data && data.map((value) => {
            if (value.type == 'name')
                data_tmp.push({ value });
        })
        if (data_tmp.length != 0) {
            handleOver(data_tmp);
        }
    }
    const handlePreReserve = () => {
        let data_tmp = [];
        data && data.map((value) => {
            if (value.type == 'both')
                data_tmp.push({ value });
        })
        if (data_tmp.length != 0) {
            handleReserve(data_tmp);
        }
    }

    return (
        <>
            {/* <Modal
                style={{ pointerEvents: 'auto' }}
                open={upload_modal}
                bodyStyle={{ backgroundColor: '#faf6f5' }}
                width={450}
                footer={false}
                className="modalStyle2"
                wrapClassName={"modalStyle2"}
                modalRender={(e) => <>
                    <div style={{ backgroundColor: '#faf6f5', padding: '30px', position: 'relative', minHeight: '25vh' }}>
                        <Row gutter={[10, 10]} justify='center' >
                            <Col span={24}>
                                <Row gutter={[10, 10]} justify={"center"}>
                                    <Col>
                                        <Button size='large' style={{ background: 'rgba(43, 193, 123, 1)', color: '#ffffff' }} onClick={(e) => handleDownload()} block>範例檔案下載</Button>
                                    </Col>
                                    <Col>
                                        <Button size='large' style={{ backgroundColor: '#41A084', color: '#FFFFFF' }} onClick={(e) => ref.current.click()} block>檔案上傳</Button>
                                        <input type="file" id="my_file" hidden ref={ref} onChange={(e) => handleImport(e)} />
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={20} style={{ position: 'absolute', bottom: '3vh' }}>
                                <Row gutter={[10, 10]} justify={"center"}>
                                    <Col>
                                        <Button size='large' style={{ background: '#4a4a4a', color: '#ffffff' }} onClick={(e) => { set_upload_modal(false); }} block>取消</Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </>}
            ></Modal> */}
            {/* <Modal
                style={{ pointerEvents: 'auto' }}
                bodyStyle={{ backgroundColor: '#faf6f5' }}
                open={import_modal}
                width={1000}
                footer={false}
                className="modalStyle2"
                wrapClassName={"modalStyle2"}
                modalRender={(e) => <>
                    <div style={{ backgroundColor: '#faf6f5', padding: '30px', borderTop: `solid #d65b77 5px `, position: 'relative', minHeight: '25vh' }}>
                        <Row gutter={[10, 10]} justify={'center'}>
                            <Col span={24}>
                                <Row gutter={[16, 10]}>
                                    <Col>
                                        <Button type='primary' onClick={handlePreReserve}>全部保留</Button>
                                    </Col>
                                    <Col>
                                        <Button style={{ backgroundColor: 'rgba(232, 79, 117, 1)', color: '#FFFFFF' }} onClick={handlePreOver}>全部覆蓋</Button>
                                    </Col>
                                    <Col>
                                        <Button style={{ background: '#4a4a4a', color: '#ffffff' }} onClick={e => set_import_modal(false)}>全部取消</Button>
                                    </Col>
                                    <Col span={24}>
                                        <ProTableOt
                                            tableLayout={'fixed'}
                                            scroll={{ x: 'max-content' }}
                                            columns={columns}
                                            dataSource={data}
                                            pagination={false}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <Col>
                                <Button style={{ background: '#4a4a4a', color: '#ffffff' }} onClick={e => set_import_modal(false)}>關閉</Button>
                            </Col>
                        </Row>
                    </div>
                </>}
            ></Modal> */}
            <Button
                variant="outline"
                type="button"
                className="flex flex-col h-20 gap-2 border-slate-200 hover:border-teal-300 hover:bg-teal-50 relative"
                onClick={(e) => handleImportModal()}
                disabled={disabled}
            >
                <Icon className="h-5 w-5 text-teal-600" />
                <span className="text-xs font-medium">{title}</span>

                {count > 0 && (
                    <div className="absolute top-2 right-2 flex items-center gap-1">
                        <Badge className="h-5 w-5 p-0 bg-teal-600 text-white text-xs rounded-full flex items-center justify-center">
                            {count}
                        </Badge>
                    </div>
                )}

                {count > 0 && <UploadPreviewRow uploadConfig={uploadConfig} mediaType={mediaType} files={uploadFiles} />}
            </Button>
            <input type="file" id="my_file" hidden ref={ref} onChange={(e) => handleImport(e)} />
        </>
    );
}